import { observable, makeObservable } from 'mobx';
import ModalParams from './ModalParams';
import { isSome } from 'core/utils';

class ConfirmModalParams extends ModalParams {
	@observable message = null;
	@observable yesLabel = 'Yes';
	@observable noLabel = 'No';

	constructor(opts) {
		super(opts);
		makeObservable(this);
		this.onConfirm = async () => {
			if (opts && opts.onConfirm) {
				this.loading = true;
				await Promise.resolve(opts.onConfirm(this.data));
				this.loading = false;
			}
			this.close();
		};

		this.onCancel = async () => {
			if (opts && opts.onCancel) {
				this.loading = true;
				await Promise.resolve(opts.onCancel(this.data));
				this.loading = false;
			}
			this.close();
		};
		if (isSome(opts.yesLabel)) {
			this.yesLabel = opts.yesLabel;
		}
		if (isSome(opts.noLabel)) {
			this.noLabel = opts.noLabel;
		}
	}
	open({ message }, data = null) {
		if (data != null) {
			this.data = data;
		}
		this.message = message;
		this.setOpen(true);
	}
}

export default ConfirmModalParams;
